angular.module("ainapp")
    .controller("ApplyLeaveController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "Apply Leave";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Components = [];
            MainService.LeavePayrollComponentsList().then(function (response) {
                $scope.Components = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            });


            $scope.calculateLeaves = function () {
                if ($scope.LeaveRequest.EmployeeId > 0 && $scope.LeaveRequest.PayrollComponentId) {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.CheckEmployeeBalanceLeave($scope.LeaveRequest.EmployeeId, $scope.LeaveRequest.PayrollComponentId)
                        .then(function (response) {
                            if (response.data) {
                                $scope.LeaveRequest.AssignedLeaves = response.data.Assigned;
                                $scope.LeaveRequest.AppliedLeaves = response.data.Applied;
                                $scope.LeaveRequest.AvailableLeaves = response.data.Balance;
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        });

                }
            }

            $scope.calculateDays = function () {
                var totDays = Math.round(($scope.LeaveRequest.ToDate - $scope.LeaveRequest.FromDate) / (1000 * 60 * 60 * 24));
                if (totDays < 0) {
                    toastr.warning("Invalid Dates Selected");
                    $scope.LeaveRequest.NoOfDays = 0;
                } else {
                    $scope.LeaveRequest.NoOfDays = Math.abs(totDays);
                    $scope.LeaveRequest.NoOfDays = $scope.LeaveRequest.NoOfDays + 1;
                    if ($scope.LeaveRequest.IsHalfDay) {
                        $scope.LeaveRequest.NoOfDays = $scope.LeaveRequest.NoOfDays - 0.5;
                    }
                }
            }

            $scope.init = function () {
                console.log($scope.TokenInfo);

                $scope.LeaveRequest = {
                    EmployeeId: "",
                    PayrollComponentId: "",
                    FromDate: new Date(),
                    ToDate: new Date(),
                    Remarks: "",
                    NoOfDays: 1,
                    AssignedLeaves: 0,
                    AvailableLeaves: 0,
                    IsHalfDay: false,
                }

                if ($scope.TokenInfo.EmployeeId > 0) {
                    $scope.LeaveRequest.EmployeeId = $scope.TokenInfo.EmployeeId;
                    $scope.calculateLeaves();
                }

                MainService.GetNextLeaveApplyNo().then(function (response) {
                    $scope.LeaveRequest.RefNo = response.data;
                });


            }
            $scope.init();



            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {

                    if (data.Status == 'New') {
                        $scope.SelectedDataForDelete = data;
                        $("#deleteModal").modal("show");
                    } else {
                        toastr.info($scope.LanguageData.CannotDeleteWhileInProcess);
                    }
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVacationRequest($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.SaveData = function () {

                //                else if ($scope.LeaveRequest.NoOfDays > $scope.LeaveRequest.AvailableLeaves) {
                //                    toastr.warning($scope.LanguageData.AvailableLeavesLessThanRequested);
                //                } 

                if ($scope.LeaveRequest.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);
                } else if ($scope.LeaveRequest.PayrollComponentId == "") {
                    toastr.warning($scope.LanguageData.SelectLeaveType);
                } else if ($scope.LeaveRequest.NoOfDays <= 0) {
                    toastr.warning($scope.LanguageData.InvalidDates);
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddLeaveApplication($scope.LeaveRequest).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }



                }]);
